import { createSelector } from 'reselect'

const getState = state => state.WorksStore

const getFetchRequest = state => getState(state).fetchWorksRequest
const getDeletingWorkRequests = state => getState(state).deletingWorkRequests

const getDeletingWorkRequest = (state, id) =>
  getDeletingWorkRequests(state)[id] || { pending: false, requestError: null }

const anyWorkDeleting = createSelector(
  [getDeletingWorkRequests],
  deletingWorksRequests => {
    for (let id in deletingWorksRequests) {
      if (deletingWorksRequests[id].pending) return true
    }
    return false
  }
)

const getWorks = state => getState(state).works

const getWorksMap = createSelector(
  [getWorks],
  works => (!works ? {} : works.entities.works)
)

const getWorksResult = createSelector(
  [getWorks],
  works => (!works ? [] : works.result)
)

const getWorksList = createSelector(
  [getWorksResult, getWorksMap],
  (result, worksMap) => result.map(id => worksMap[id])
)

const getWork = (state, id) => getWorksMap(state)[id]

const getPagination = state => getState(state).pagination

export {
  getFetchRequest,
  getWorksList,
  getWork,
  getDeletingWorkRequest,
  getWorksResult,
  getPagination,
  anyWorkDeleting,
  getState as getWorksState
}
